import classNames from "classnames";
import { TextFieldProps } from "./types";
import styles from "./TextField.module.scss";

export function TextField({
  width,
  value,
  onChange,
  onBlur,
  onFocus,
  variant = "outlined",
  startIcon,
  endIcon,
  size = "m",
  isStartJSX,
  isEndJSX,
  isDisabled,
  isError,
  textAlign = "start",
  label,
  isMedia,
  isMobile,
  isBorder,
  ...attributes
}: TextFieldProps) {
  return (
    <div className={styles.inputContainer} style={{ width }}>
      {label && (
        <div className={styles.inputLabel} is-media={isMedia} is-mobile={isMobile}>{label}</div>
      )}
      <input
        {...attributes}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        data-variant={variant}
        data-size={size}
        is-media={isMedia}
        is-mobile={isMobile}
        is-border={isBorder}
        className={classNames(
          startIcon ? styles.input_root__start_icon : "",
          endIcon ? styles.input_root__end_icon : "",
          startIcon && endIcon ? styles.input_root__icons : "",
          isError ? styles.input_error : "",

          textAlign === "start" ? styles.input_text_start : "",
          textAlign === "center" ? styles.input_text_center : "",
          textAlign === "end" ? styles.input_text_end : "",
        )}
        disabled={isDisabled}
      />
      <div
        className={
          !isStartJSX ? styles.startIconContainer : styles.startIconContainerJSX
        }
      >
        {startIcon}
      </div>
      <div
        className={
          !isEndJSX ? styles.endIconContainer : styles.endIconContainerJSX
        }
      >
        {endIcon}
      </div>
    </div>
  );
}
